import { Routes, Route, useLocation } from "react-router-dom";
import SignIn from "./Components/SignIn/SignIn";
import CandidateDashboard from "./Components/Candidate/CandidateDashboard/CandidateDashboard";
import TaskManagement from "./Components/Candidate/TaskManagement";
import UpdateCandidate from "./Components/Candidate/UpdateCandidate";
import PostedJobs from "./Components/Vendor/PostedJobs";
import CreateJobForm from "./Components/Vendor/CreateJob/CreateJobForm.jsx";
import NewJobs from "./Components/Candidate/Job/NewJobs/NewJobs";
import ScheduleInterview from "./Components/Vendor/interview/ScheduleInterview.jsx";
import ApplyJobList from "./Components/Vendor/ApplyJobList";
import InterviewHistory from "./Components/Vendor/interview/InterviewHistory";
import InterviewPlanned from "./Components/Vendor/interview/InterviewPlanned";
import TeamList from "./Components/Vendor/TeamManage/TeamList.jsx";
import RequestedProfile from "./Components/Vendor/TeamManage/RequestedProfile.jsx";
import AddTeam from "./Components/Vendor/TeamManage/AddTeam";
import ApplyCandidateProfile from "./Components/Vendor/Profile/ApplyCandidateProfile";
import JobWorkOrder from "./Components/Vendor/JobWorkOrder/JobWorkOrder";
import AddSprintDetail from "./Components/Vendor/JobWorkOrder/AddSprintDetail";
import JobRequest from "./Components/Candidate/Job/JobRequest";
import AppliedJobs from "./Components/Candidate/Job/AppliedJobstemp";
import JobDescription from "./Components/Candidate/Job/JobDescription";
import OtpVerify from "./Components/Vendor/OtpVerify/OtpVerify.jsx";
import JobsInterviewHistory from "./Components/Candidate/Job/JobsInterviewHistory";
import JobsInterviewPlanned from "./Components/Candidate/Job/JobsInterviewPlanned";
import NewPassword from "./Components/NewPassword";
import VotpVerify from "./Components/Vendor/VotpVerify";
import VerifyResetOtp from "./Components/VerifyResetOtp";
import Forgotpass from "./Components/Forgotpass";
import ViewJob from "./Components/Candidate/Job/ViewJob/ViewJob";
import Protected from "./utils/Protected";
import AllCandidateList from "./Components/Vendor/AllCandidateList";
import CandidateProfileView from "./Components/Vendor/Profile/CandidateProfileView";
import AllNewJobsList from "./Components/Vendor/vendorJobList/AllNewJobsList.js";
import WorkPrefrence from "./Components/Candidate/WorkPrefrence";
import AllPreferences from "./Components/Candidate/AllPreferences";
import ImportCandidates from "./Components/Vendor/ImportCandidates";
import VendorProfile from "./Components/Vendor/VendorProfile/VendorProfile";
import ArchivedMembers from "./Components/Vendor/TeamManage/ArchivedMembers";
import TeamAppliedJobs from "./Components/Vendor/TeamManage/TeamAppliedJobs";
// import GuestCandidateList from "./Components/Guest/GuestCandidateList";
import ProjectForm from "./Components/Candidate/Project/AddCandidateProjects";
import ListProjects from "./Components/Candidate/Project/ListProjects";
// import LandingPage from "./Components/Landing/LandingPage";
import Registration from "./Components/SignIn/Registration";
import Header from "./Components/Common/Header/Header";
import Profile from "./Components/Candidate/Profile/Profile";
import UpdateProjectForm from "./Components/Candidate/Project/UpdateProject";
import Breadcrumb from "./Components/Common/breadcrumb/Breadcrumb";
import ApplicationStatus from "./Components/Candidate/Job/ApplicationStatus";
import VendorDashboard from "./Components/Vendor/VendorDashboard/VendorDashboard";
import ViewCandidate from "./Components/Vendor/TeamManage/ViewCandidate.jsx";
import OtpVerifyTemp from "./Components/Vendor/OtpVerify/OtpVerifyTemp.js";
import RepostJob from "./Components/Vendor/vendorJobList/RepostJob.jsx";
import JobDetails from "./Components/Vendor/JobDetails.jsx";
import AssignedInterviews from "./Components/Candidate/Job/AssignedInterviews.js";
import AssignedInterviewsInfo from "./Components/Candidate/Job/AssignedInterviewsInfo.jsx";
import ScheduledInterviewMoreInfo from "./Components/Vendor/interview/ScheduledInterviewMoreInfo.jsx";
import InterviewListTeamMember from "./Components/Vendor/VendorDashboard/InterviewListTeamMember.jsx";
import ShowAllProjects from "./Components/Candidate/Project/ShowAllProjects.jsx";
import Dashboard from "./Dashboard/Dashboard.js";
// import Content from "./Components/Admin/Content.js";
import VendorPage from "./Components/Admin/pages/VendorPage.js";
import ViewVendor from "./Components/Admin/component/ViewVendor.js";
import CandidatePage from "./Components/Admin/pages/CandidatePage.js";
import JobPage from "./Components/Admin/pages/JobPage.js";
import InterviewPage from "./Components/Admin/pages/InterviewPage.js";
import AdminProtected from "./utils/AdminProtected.js";
import OrderPage, {
  PurchaseOrderList,
} from "./Components/Admin/pages/OrderPage.js";
import ViewOrderPage from "./Components/Admin/component/ViewOrderPage.js";
import VendorPurchase from "./Components/Vendor/purchaseManage/VendorPurchase.js";
import PurchaseOrderDetails from "./Components/Vendor/purchaseManage/PurchaseOrderDetails.js";
import ProtectRoute from "./utils/ProtectRoute.js";
import AdminSignIn from "./Components/SignIn/AdminSignIn.js";
import FreePlan from "./Components/Vendor/Subscription/FreePlan.jsx";
import SubscriptionPage from "./Components/Admin/pages/SubscriptionPage.js";
import ViewSubscriptionPage from "./Components/Admin/pages/ViewSubscriptionPage.js";
import CandidateSubscription from "./Components/Candidate/Subscription/CandidateSubscription.js";
import VendorJobs from "./Components/Admin/pages/VendorJobs.js";
import UpdateTeam from "./Components/Vendor/TeamManage/UpdateTeam.jsx";
// import useAuthCheck from "./Hooks/useAuthCheck.js";
import WebSocketLogout from "./utils/WebSocketLogout.js";
import AppliedCandidateView from "./Components/Vendor/TeamManage/AppliedCandidateView.jsx";
import InterviewAllRounds from "./Components/Vendor/interview/InterviewAllRounds.js";
import NewLandingPage from "./Components/Landing/NewLandingPage.jsx";
// import PageNotFound from "./Components/Landing/components/PageNotFound.jsx";
import Navbar from "./Components/Landing/components/Navbar/Navbar.jsx";
import ContactUs from "./Components/Landing/components/ContactUs/ContactUs.jsx";
import AboutUs from "./Components/Landing/components/AboutUs/AboutUs.jsx";
import Career from "./Components/Landing/Career/Career.jsx";
import { useSelector } from "react-redux";
import ScrollToTop from "./Components/Common/ScrollToTop.js";
import Solutions from "./Components/Landing/pages/Solutions.jsx";
import Demo from "./Components/Landing/pages/Demo.jsx";
import Resources from "./Components/Landing/pages/Resources.jsx";
import PriceManagement from "./Components/Admin/pricing/PriceManagement.jsx";
import VendorViewCandidate from "./Components/Vendor/TeamManage/VendorViewCandidate.jsx";
import InterviewInvitation from "./Components/Admin/component/InterviewInvitation.jsx";
import ConfirmedInterviews from "./Components/Candidate/Job/ConfirmedInterviews.jsx";
import AdminDashboard from "./Components/Admin/AdminDashboard.jsx";
import InterviewApprovals from "./Components/Vendor/interviewApprovals/InterviewApprovals.jsx";
import ConfirmInterviews from "./Components/Vendor/confirmInterviews/ConfirmInterviews.jsx";
import JobsList from "./Components/Landing/components/Jobs/JobList.jsx";
import JobDetailsLanding from "./Components/Landing/components/Jobs/JobDetails.jsx";
import TeamListV2 from "./Components/Vendor/TeamManage/TeamListV2.jsx";

const breadcrumbItems = {
  "/new_job": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Jobs", url: "/" },
  ],
  "/view_job": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Jobs", url: "/new_job" },
    { text: "View Job", url: "/" },
  ],
  "/view_job/:id": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Jobs", url: "/new_job" },
    { text: "View Job", url: "/" },
  ],
  "/add-candidate-projects": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Projects", url: "/show-candidate-projects" },
    { text: "Add Project", url: "/" },
  ],
  "/show-candidate-projects": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Projects", url: "/" },
  ],
  "/candidate-profile": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Profile", url: "/" },
  ],
  "/application_status": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Jobs", url: "/new_job" },
    { text: "Application Status", url: "/" },
  ],
  "/candidate_interviews": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Interviews", url: "/" },
  ],
  "/assigned_interviews": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Interviews", url: "candidate_interviews" },
    { text: "Assigned Interviews", url: "/" },
  ],
  "/assigned_interviews_info/:id": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Interviews", url: "candidate_interviews" },
    { text: "Assigned Interviews", url: "/assigned_interviews" },
    { text: "Assigned Interviews Info", url: "/" },
  ],
  "/interviews_info/:id": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Interviews", url: "candidate_interviews" },
    { text: "Interviews Info", url: "/" },
  ],
  "/confirmed_interviews": [
    { text: "Candidate Dashboard", url: "/candidate_dashboard" },
    { text: "Interviews", url: "/candidate_interviews" },
    { text: "Confirmed Interviews", url: "/" },
  ],
};

const vendor_breadcrumbItems = {
  "/team-list": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/" },
  ],
  "/interview-approvals": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Interview Approvals", url: "/" },
  ],
  "/vendor/confirm-interviews": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Interview Approvals", url: "/interview-approvals" },
    { text: "Confirm Interviews", url: "/" },
  ],
  "/requested-candidate": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/team-list" },
    { text: "Requested Candidates", url: "/" },
  ],
  "/import_candidates": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/team-list" },
    { text: "Import Candidates", url: "/" },
  ],
  "/add-team": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/team-list" },
    { text: "Add Team Member", url: "/" },
  ],
  "/archived_members": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/team-list" },
    { text: "Archived Member", url: "/" },
  ],
  "/schedule-interview": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Scheduled Interviews", url: "/" },
  ],
  "/interview-history": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Schedule Interview", url: "/schedule-interview" },
    { text: "Interview History", url: "/" },
  ],
  "/interview_all_rounds/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Schedule Interview", url: "/schedule-interview" },
    { text: "Interview History", url: "/interview-history" },
    { text: "Interview All Rounds", url: "/" },
  ],
  "/all-new-jobs-list": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs", url: "/" },
  ],
  "/candidate-profile-view/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/team-list" },
    { text: "Deactivated Team Members", url: "/" },
  ],
  "/update-team/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Team Members", url: "/team-list" },
    { text: "Update Team Member", url: "/" },
  ],
  "/view_job": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs", url: "/all-new-jobs-list" },
    { text: "View Job", url: "/" },
  ],
  "/view_job/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs", url: "/all-new-jobs-list" },
    { text: "View Job", url: "/" },
  ],
  "/posted_jobs": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/" },
  ],
  "/create_job": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Create Job", url: "/" },
  ],
  "/vendor_profile": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Profile", url: "/" },
  ],
  "/all-candidate-list": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "All Candidates", url: "/" },
  ],
  "/apply-job-list": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Applied Candidates", url: "/" },
  ],
  "/apply-job-list/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Applied Candidates", url: "/" },
  ],
  "/job-details": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Job Detail", url: "/" },
  ],
  "/job-details/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Job Detail", url: "/" },
  ],

  "/scheduled-more-info": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Scheduled Interviews", url: "/schedule-interview" },
    { text: "Scheduled Interviews More Info", url: "/" },
  ],

  "/teammember-more-info": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Scheduled Interviews", url: "/schedule-interview" },
    { text: "Team Member Interviews", url: "/teamMember-interview" },
    { text: "Team Member Interviews more info", url: "/" },
  ],

  "/teamMember-interview": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Scheduled Interviews", url: "/schedule-interview" },
    { text: "Team Member Interview", url: "/" },
  ],

  "/edit_job": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Edit Job", url: "/" },
  ],
  "/edit_Validity_job/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Edit Job", url: "/" },
  ],
  "/repost_job": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Repost Job", url: "/" },
  ],
  "/post_job/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Post Job", url: "/" },
  ],
  "/repost_job/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Jobs Management", url: "/posted_jobs" },
    { text: "Repost Job", url: "/" },
  ],
  "/purchase-details": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Purchase Order Management", url: "/" },
  ],
  "/view_candidate/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "All Candidates", url: "/all-candidate-list" },
    { text: "Team Members", url: "/" },
  ],
  "/vendor/view_candidate/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "All Candidates", url: "/all-candidate-list" },
    { text: "Candidate", url: "/" },
  ],
  "/scheduled-more-info/:id": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Scheduled Interviews", url: "/schedule-interview" },
    { text: "Scheduled Interviews More Info", url: "/" },
  ],
  "/subscription": [
    { text: "Vendor Dashboard", url: "/vendor_dashboard" },
    { text: "Subscription", url: "/" },
  ],
};

const extractBasePath = (pathname, breadcrumbMap) => {
  if (pathname.includes("admin")) {
    const parts = pathname?.split("/").slice(-1)[0].split("?")[0];
    return `/${parts}`;
  }

  const routeKeys = Object.keys(breadcrumbMap);

  for (const route of routeKeys) {
    const pattern = "^" + route.replace(/:\w+/g, "[^/]+") + "$";
    const regex = new RegExp(pattern);
    if (regex.test(pathname)) {
      // console.log(`Matched route "${route}" for path "${pathname}"`);
      return route;
    }
  }

  const parts = pathname.split("/");
  const fallback = `/${parts[parts.length - 1]}`;
  // console.log(`No match found for "${pathname}", fallback to "${fallback}"`);
  return fallback;
};

const Home = () => {
  // useAuthCheck();
  const noHeaderRoutes = [
    "/login",
    "/ebench/jobs",
    "/contact-us",
    "/about-us",
    "/solutions",
    "/admin-login",
    "/register",
    "/otp-verify",
    "/votp-verify",
    "/verify-reset-otp",
    "/new-password",
    "/forgot-pass",
    "/otp-verify2",
    "/",
    "/demo",
    "/resources",
    "/careers",
    "/guest",
    "/admin",
    "/admin/vendor",
    "/admin/vendor/view",
    "/admin/candidate",
    "/admin/candidate/viewCandidate",
    "/admin/job",
    "/admin/job/vendor_jobs",
    "/admin/job/viewJob",
    "/admin/interview",
    "/admin/interview/interviews_info",
    "/admin/interview/interviews_info/:id",
    "/admin/team-list",
    "/admin/posted_jobs",
    "/admin/view/team-member",
    "/admin/view/job-details",
    "/admin/selected-candidate",
    "/admin/selected-candidate/details",
    "/admin/purchase_order",
    "/admin/purchase_order/detail",
    "/admin/subscription",
    "/admin/subscription/details",
    "/admin/price-management",
    "/admin/interview/invitations",
    "/ebench/jobs-details/:id",
  ];
  const { userResult } = useSelector((state) => state.Auth);
  const userType = userResult?.usertype || localStorage.getItem("usertype");
  const candidateVendorId = localStorage.getItem("candidateVendorId");
  const dynamicNoHeaderRoutes = [
    /^\/admin\/vendor\/\d+$/,
    /^\/admin\/candidate\/\d+$/,
    /^\/admin\/job\/\d+$/,
    /^\/admin\/interview\/interviews_info\/\d+$/,
    /^\/ebench\/jobs-details\/\d+$/,
  ];
  const shouldHideHeader =
    noHeaderRoutes.includes(window.location.pathname) ||
    dynamicNoHeaderRoutes.some((regex) => regex.test(window.location.pathname));
  const location = useLocation();
  const currentPath = location.pathname;
  const basePath = extractBasePath(currentPath, {
    ...breadcrumbItems,
    ...vendor_breadcrumbItems,
  });

  if (shouldHideHeader) {
    return (
      <>
        <WebSocketLogout />
        <Routes>
          <Route path="/" element={<NewLandingPage />} />
          <Route path="/ebench/jobs" element={<JobsList />} />
          <Route
            path="/ebench/jobs-details/:id"
            element={<JobDetailsLanding />}
          />
          <Route path="/register" element={<Registration />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/otp-verify" element={<OtpVerify />} />
          <Route path="/otp-verify2" element={<OtpVerifyTemp />} />
          <Route path="/forgot-pass" element={<Forgotpass />} />
          <Route path="/votp-verify" element={<VotpVerify />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/admin-login" element={<AdminSignIn />} />
          {/* <Route path="/guest" element={<GuestCandidateList />} /> */}
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/careers" element={<Career />} />

          {/* <Route path="*" element={<PageNotFound />}></Route> */}

          <Route
            path="/admin/"
            element={
              <ProtectRoute>
                <Dashboard />
              </ProtectRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="vendor" element={<VendorPage />} />
            <Route
              path="interview/interviews_info/:interviewId"
              element={<AdminProtected Component={AssignedInterviewsInfo} />}
            />
            <Route
              path="vendor/view"
              element={<AdminProtected Component={ViewVendor} />}
            />
            <Route
              path="interview/invitations"
              element={<AdminProtected Component={InterviewInvitation} />}
            />
            <Route
              path="price-management"
              element={<AdminProtected Component={PriceManagement} />}
            />
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route
              path="subscription/details"
              element={<ViewSubscriptionPage />}
            />
            <Route path="candidate" element={<CandidatePage />} />

            <Route
              path="candidate/viewCandidate"
              element={<AdminProtected Component={ViewCandidate} />}
            />
            <Route path="job" element={<JobPage />} />
            <Route
              path="job/viewJob"
              element={<AdminProtected Component={ViewJob} />}
            />
            <Route path="interview" element={<InterviewPage />} />
            <Route
              path="interview/interviews_info"
              element={<AdminProtected Component={AssignedInterviewsInfo} />}
            />

            <Route
              path="team-list"
              element={<AdminProtected Component={TeamList} />}
            />
            <Route path="view/team-member" element={<ViewCandidate />} />
            <Route path="view/job-details" element={<ViewJob />} />
            <Route
              path="posted_jobs"
              element={<AdminProtected Component={PostedJobs} />}
            />
            <Route
              path="job/vendor_jobs"
              element={<AdminProtected Component={VendorJobs} />}
            />
            <Route path="selected-candidate" element={<OrderPage />} />
            <Route
              path="purchase_order"
              element={<AdminProtected Component={PurchaseOrderList} />}
            />
            <Route
              path="purchase_order/detail"
              element={<AdminProtected Component={ViewOrderPage} />}
            />
            <Route
              path="selected-candidate/details"
              element={<AdminProtected Component={ViewOrderPage} />}
            />
            {/* <Route path="*" element={<PageNotFound />} /> */}
          </Route>
        </Routes>
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <WebSocketLogout />
      {userType ? <Header /> : <Navbar />}
      {userType === "CANDIDATE" && breadcrumbItems[basePath]?.length > 0 && (
        <Breadcrumb items={breadcrumbItems[basePath]} />
      )}

      {userType === "VENDOR" &&
        vendor_breadcrumbItems[basePath]?.length > 0 && (
          <Breadcrumb
            candidateVendorId={candidateVendorId}
            items={vendor_breadcrumbItems[basePath] || []}
          />
        )}
      <Routes>
        {/* <Route path="*" element={<PageNotFound />} /> */}
        <Route
          path="/invitations"
          element={<Protected Component={RequestedProfile} />}
        />
        <Route
          path="/requested-candidate"
          element={<Protected Component={RequestedProfile} />}
        />
        <Route
          path="/teamMember-interview"
          element={<Protected Component={InterviewListTeamMember} />}
        />
        <Route
          path="/teammember-more-info/:interviewId"
          element={<Protected Component={ScheduledInterviewMoreInfo} />}
        />
        <Route
          path="/scheduled-more-info/:interviewId"
          element={<Protected Component={ScheduledInterviewMoreInfo} />}
        />
        <Route
          path="/interviews_info/:interviewId"
          element={<Protected Component={AssignedInterviewsInfo} />}
        />
        <Route
          path="/assigned_interviews_info/:interviewId"
          element={<Protected Component={AssignedInterviewsInfo} />}
        />
        <Route
          path="/assigned_interviews"
          element={<Protected Component={AssignedInterviews} />}
        />
        <Route
          path="/candidate_dashboard"
          element={<Protected Component={CandidateDashboard} />}
        />
        <Route
          path="/task_management"
          element={<Protected Component={TaskManagement} />}
        />
        <Route
          path="/update_candidate"
          element={<Protected Component={UpdateCandidate} />}
        />
        <Route
          path="/vendor_dashboard"
          element={<Protected Component={VendorDashboard} />}
        />
        <Route
          path="/interview-approvals"
          element={<Protected Component={InterviewApprovals} />}
        />
        <Route
          path="/vendor/confirm-interviews"
          element={<Protected Component={ConfirmInterviews} />}
        />
        <Route
          path="/vendor_subscription"
          element={<Protected Component={FreePlan} />}
        />
        <Route
          path="/subscription"
          element={<Protected Component={CandidateSubscription} />}
        />
        <Route
          path="/posted_jobs"
          element={<Protected Component={PostedJobs} />}
        />
        <Route
          path="/vendor_profile"
          element={<Protected Component={VendorProfile} />}
        />
        <Route
          path="/create_job"
          element={<Protected Component={CreateJobForm} />}
        />
        <Route path="/new_job" element={<Protected Component={NewJobs} />} />
        <Route
          path="/view_job/:id"
          element={<Protected Component={ViewJob} />}
        />
        <Route
          path="/schedule-interview"
          element={<Protected Component={ScheduleInterview} />}
        />
        <Route
          path="/apply-job-list/:id"
          element={<Protected Component={ApplyJobList} />}
        />
        <Route
          path="/applied-candidate-view/:id"
          element={<Protected Component={AppliedCandidateView} />}
        />
        <Route
          path="/interview-history"
          element={<Protected Component={InterviewHistory} />}
        />
        <Route
          path="/interview_all_rounds/:id"
          element={<Protected Component={InterviewAllRounds} />}
        />
        <Route
          path="/interview-planned"
          element={<Protected Component={InterviewPlanned} />}
        />
        <Route
          path="/application_status"
          element={<Protected Component={ApplicationStatus} />}
        />
        <Route
          path="/all-preferences"
          element={<Protected Component={AllPreferences} />}
        />
        <Route path="/team-list" element={<Protected Component={TeamListV2} />} />
        <Route path="/add-team" element={<Protected Component={AddTeam} />} />
        <Route
          path="/update-team/:id"
          element={<Protected Component={UpdateTeam} />}
        />
        <Route
          path="/view_candidate/:id"
          element={<Protected Component={ViewCandidate} />}
        />
        <Route
          path="/vendor/view_candidate/:candidateId"
          element={<Protected Component={VendorViewCandidate} />}
        />
        <Route
          path="/archived_members"
          element={<Protected Component={ArchivedMembers} />}
        />
        <Route
          path="/apply-candidate-profile/:id"
          element={<Protected Component={ApplyCandidateProfile} />}
        />
        <Route
          path="/candidate-profile-view/:id"
          element={<Protected Component={CandidateProfileView} />}
        />
        <Route
          path="/candidate-profile"
          element={<Protected Component={Profile} />}
        />
        <Route
          path="/job-work-order"
          element={<Protected Component={JobWorkOrder} />}
        />
        <Route
          path="/add-sprint-detail/:mileStoneName/:id"
          element={<Protected Component={AddSprintDetail} />}
        />
        <Route
          path="/job-request"
          element={<Protected Component={JobRequest} />}
        />
        <Route
          path="/applied-jobs"
          element={<Protected Component={AppliedJobs} />}
        />
        <Route
          path="/team_applied_jobs"
          element={<Protected Component={TeamAppliedJobs} />}
        />
        <Route
          path="/job-description/:id"
          element={<Protected Component={JobDescription} />}
        />
        <Route
          path="/job-details/:id"
          element={<Protected Component={JobDetails} />}
        />
        <Route
          path="/jobs-history"
          element={<Protected Component={JobsInterviewHistory} />}
        />
        <Route
          path="/candidate_interviews"
          element={<Protected Component={JobsInterviewPlanned} />}
        />
        <Route
          path="/confirmed_interviews"
          element={<Protected Component={ConfirmedInterviews} />}
        />
        <Route
          path="/all-preferences"
          element={<Protected Component={JobsInterviewPlanned} />}
        />
        <Route
          path="/work-prefrence"
          element={<Protected Component={WorkPrefrence} />}
        />
        <Route
          path="/repost_job/:id"
          element={<Protected Component={RepostJob} />}
        />
        <Route
          path="/edit_Validity_job/:id"
          element={<Protected Component={RepostJob} />}
        />
        <Route
          path="/post_job/:id"
          element={<Protected Component={RepostJob} />}
        />
        <Route
          path="/all-candidate-list"
          element={<Protected Component={AllCandidateList} />}
        />
        <Route
          path="/import_candidates"
          element={<Protected Component={ImportCandidates} />}
        />
        <Route
          path="/all-new-jobs-list"
          element={<Protected Component={AllNewJobsList} />}
        />
        <Route
          path="/add-candidate-projects"
          element={<Protected Component={ProjectForm} />}
        />
        <Route
          path="/show-candidate-projects"
          element={<Protected Component={ShowAllProjects} />}
        />
        <Route
          path="/update-candidate-projects/:id"
          element={<Protected Component={UpdateProjectForm} />}
        />
        <Route
          path="/candidate-projects"
          element={<Protected Component={ListProjects} />}
        />
        <Route
          path="/purchase-details"
          element={<Protected Component={VendorPurchase} />}
        />
        <Route
          path="/purchase-details/details"
          element={<Protected Component={PurchaseOrderDetails} />}
        />
      </Routes>
    </>
  );
};

export default Home;
